export const VIMEO_REGEX = /(?:https?:\/\/)?(?:www\.)?vimeo\.com\/(?:\w+\/)*(\d+)/
export const VIMEO_REGEX_GLOBAL = /(?:https?:\/\/)?(?:www\.)?vimeo\.com\/(?:\w+\/)*(\d+)/g

export function isValidVimeoUrl(url: string): boolean {
    return VIMEO_REGEX.test(url)
}

interface VimeoUrlOptions {
    url: string
    [key: string]: any
}

export function getEmbedUrlFromVimeoUrl(options: VimeoUrlOptions): string | null {
    const { url, ...params } = options

    if (!isValidVimeoUrl(url)) {
        return null
    }

    const videoIdMatch = url.match(VIMEO_REGEX)
    const videoId = videoIdMatch ? videoIdMatch[1] : null

    if (!videoId) {
        return null
    }

    const embedUrl = new URL(`https://player.vimeo.com/video/${videoId}`)

    for (const key in params) {
        const value = params[key]
        if (value !== undefined) {
            embedUrl.searchParams.append(key, String(value))
        }
    }

    return embedUrl.toString()
}
